import { render, staticRenderFns } from "./Forget_password.vue?vue&type=template&id=0c6f4add&"
import script from "./Forget_password.vue?vue&type=script&lang=js&"
export * from "./Forget_password.vue?vue&type=script&lang=js&"
import style0 from "./Forget_password.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports